import { useState } from "react";
import Img from "./Img";
import Svg from "./Svg";
import Thumb from "./Thumb";

export default function Carousel() {
    const [picId, setPicId] = useState(1);

    function addId() {
        if (picId === 4) {
            return setPicId(1);
        } else {
            setPicId(picId + 1);
        }
    }

    function subId() {
        if (picId === 1) {
            return setPicId(4);
        } else {
            setPicId(picId - 1);
        }
    }

    const [iconPressed, setIconPressed] = useState(false);

    function handleIcon() {
        setIconPressed(true);
        document.querySelector(".navbar").style.backgroundColor =
            "rgba(0,0,0,0.4)";
    }

    function handleIconF() {
        setIconPressed(false);
        document.querySelector(".navbar").style.backgroundColor = "white";
    }

    const [lpic, setLpic] = useState(1);

    function addLpic() {
        if (lpic === 4) {
            return setLpic(1);
        } else {
            setLpic(lpic + 1);
        }
    }

    function subLpic() {
        if (lpic === 1) {
            return setLpic(4);
        } else {
            setLpic(lpic - 1);
        }
    }

    return (
        <>
            <div className="slideshow-container">
                <div
                    onClick={handleIcon}
                    className={`mySlides ${picId === 1 ? "show" : ""}`}
                >
                    <Img number={1} />
                </div>
                <div
                    onClick={handleIcon}
                    className={`mySlides ${picId === 2 ? "show" : ""}`}
                >
                    <Img number={2} />
                </div>
                <div
                    onClick={handleIcon}
                    className={`mySlides ${picId === 3 ? "show" : ""}`}
                >
                    <Img number={3} />
                </div>
                <div
                    onClick={handleIcon}
                    className={`mySlides ${picId === 4 ? "show" : ""}`}
                >
                    <Img number={4} />
                </div>

                <a onClick={subId} href="#" className="previous round">
                    &#8249;
                </a>
                <a onClick={addId} href="#" className="next round">
                    &#8250;
                </a>
            </div>
            <div className="thumbnail-pics">
                <div onClick={() => setPicId(1)} className="thumbnail">
                    <Thumb number={1} />
                </div>
                <div onClick={() => setPicId(2)} className="thumbnail">
                    <Thumb number={2} />
                </div>
                <div onClick={() => setPicId(3)} className="thumbnail">
                    <Thumb number={3} />
                </div>
                <div onClick={() => setPicId(4)} className="thumbnail">
                    <Thumb number={4} />
                </div>
            </div>
            {/* -------------------------Lightbox------------------------ */}
            <div className={`lb-bg ${iconPressed ? "show-l" : ""}`}>
                <div className={`lightbox ${iconPressed ? "show-l" : ""}`}>
                    <div className="lightbox-images">
                        <div
                            className={`lightbox-slides ${
                                lpic === 1 ? "show-l" : ""
                            }`}
                        >
                            <Img number={1} />
                        </div>
                        <div
                            className={`lightbox-slides ${
                                lpic === 2 ? "show-l" : ""
                            }`}
                        >
                            <Img number={2} />
                        </div>
                        <div
                            className={`lightbox-slides ${
                                lpic === 3 ? "show-l" : ""
                            }`}
                        >
                            <Img number={3} />
                        </div>
                        <div
                            className={`lightbox-slides ${
                                lpic === 4 ? "show-l" : ""
                            }`}
                        >
                            <Img number={4} />
                        </div>

                        <a
                            onClick={subLpic}
                            href="#"
                            className={`previous2 round ${
                                iconPressed ? "show-l" : ""
                            }`}
                        >
                            &#8249;
                        </a>
                        <a
                            onClick={addLpic}
                            href="#"
                            className={`next2 round ${
                                iconPressed ? "show-l" : ""
                            }`}
                        >
                            &#8250;
                        </a>
                        <a
                            type="button"
                            className="close-lightbox"
                            onClick={handleIconF}
                        >
                            <Svg name="close" />
                        </a>
                    </div>
                    <div className="thumbnail-p">
                        <div
                            onClick={() => setLpic(1)}
                            className="thumb-lightbox"
                        >
                            <Thumb number={1} />
                        </div>
                        <div
                            onClick={() => setLpic(2)}
                            className="thumb-lightbox"
                        >
                            <Thumb number={2} />
                        </div>
                        <div
                            onClick={() => setLpic(3)}
                            className="thumb-lightbox"
                        >
                            <Thumb number={3} />
                        </div>
                        <div
                            onClick={() => setLpic(4)}
                            className="thumb-lightbox"
                        >
                            <Thumb number={4} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
